<footer class="component-main-footer">
  <div class="grid-flex grid-full-center flex-column">
    <div>
      <a href="https://www.fordham.edu/" target="_blank">
        <img src="assets/images/logo-white.svg" class="component-main-footer__logo" alt="">
      </a>
    </div>
    <div>
      <p><a routerLink="/contact">Contact Us</a></p>
    </div>
  </div>
  <div class="component-main-footer__scroll-top" (click)="scrollToTop()"></div>
</footer>
